import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { SelfDeclarationDto, SelfDeclarationService } from 'src/api/v2';
import { SIVA_REPORT_DECLARATION } from 'src/constants/hook-keys';

export const useSelfDeclaration = (year: number) => {
  const [selfDeclarationService] = useState(() => new SelfDeclarationService());
  const queryClient = useQueryClient();

  const { data } = useQuery({
    queryFn: () => selfDeclarationService.getList(year),
    queryKey: [SIVA_REPORT_DECLARATION, year],
  });

  const upsertDto = useMutation({
    mutationFn: (dto: SelfDeclarationDto) => {
      if (!dto) return Promise.reject('An object was not provided properly.');
      return selfDeclarationService.upsert(dto);
    },
    onSuccess: () => queryClient.invalidateQueries([SIVA_REPORT_DECLARATION, year]),
  });

  return { data, upsertDto };
};
